import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { HTTP_VERBS } from 'utils/constants';
import { ALERT_VARIANTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';
import { LOCALIZATION_PAGES } from 'utils/constants';
import { API_ENDPOINTS } from 'utils/constants';

const path = API_ENDPOINTS.VENUES;

const useVenueUpdateLayout = id => {
  const { t } = useTranslation(LOCALIZATION_PAGES.VENUES);
  const { showNotification } = useRoot();

  const [{ result: updateVenueLayoutResult, loading: loadingUpdateLayoutVenue, error }, updateVenue] = useApi(
    `${path}/${id}/layout`,
    {
      initialFetch: false,
      verb: HTTP_VERBS.PUT,
    }
  );

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('layout_save_failed'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (updateVenueLayoutResult) {
      showNotification({
        message: t('layout_save_success'),
      });
    }
  }, [updateVenueLayoutResult, showNotification, t]);

  return [{ updateVenueLayoutResult, loadingUpdateLayoutVenue, error }, updateVenue];
};

export default useVenueUpdateLayout;
